module.exports = __webpack_public_path__ + "img/vedioMoRen.1630993415105.png";